module.exports = __webpack_public_path__ + "img/base_divers_services_medicaux.11be3d6b.svg";